import { Injectable } from '@angular/core';
import { BaseTableService } from './base-table.service';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '@mobileia/authentication';
import { Section } from '../entities/section';

@Injectable({
  providedIn: 'root'
})
export class SectionService extends BaseTableService<Section> {

  constructor(
    protected http: HttpClient,
    protected authService: AuthenticationService
  ) {
    super(http, authService);
    this.basePathUrl = 'admin/section';
  }
  
}
